module.exports = __webpack_public_path__ + "static/media/profissionais.309aeccd.svg";